"use strict";

import angular from "angular";

angular.module("nucont.accounting.contactsManagment", ["nucont.shared"]);
require("./contacts-managment.templates");
require("./contacts-management.routes");
